import { render, staticRenderFns } from "./SubscriptionTouchActions.vue?vue&type=template&id=78a1b115&scoped=true&"
import script from "./SubscriptionTouchActions.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionTouchActions.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionTouchActions.vue?vue&type=style&index=0&id=78a1b115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1b115",
  null
  
)

export default component.exports